<app-device-features-container
  actionButtonName="{{
    '+INSTALLATIONS.INSTALLATION.FEATURE_CONTAINER.DETAILS_BUTTON' | translate
  }}"
  [header]="header"
  [overlayType]="availableOverlays.CircuitHeatingZone"
  [deviceSelectId]="deviceSelectId"
  [heatingCircuitId]="circuitId"
  [isMoreActions]="heatingZoneNameFeature$ | async | ready | executable: 'setName'"
>
  <div header>
    <app-pill
      *ngIf="pumpStatus$ | async | ready as feature"
      type="{{ (feature | value2: 'status') === 'on' ? pillType.success : pillType.secondary }}"
    >
      <ng-container *ngIf="feature | value2: 'active'">
        {{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.PUMP_ON_CHIP' | translate }}
      </ng-container>
      <ng-container *ngIf="!(feature | value2: 'active')">
        {{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.PUMP_OFF_CHIP' | translate }}
      </ng-container>
    </app-pill>
  </div>

  <!-- heating.circuits.${circuitId}.operating.programs.active -->
  <app-feature-tile
    *ngIf="operatingProgramsActive$ | async | ready as feature"
    feature
    label="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.PROGRAM' | translate }}"
    value="{{ operatingProgramName$ | async | translate }}"
    [attr.data-feature]="feature.feature"
  >
  </app-feature-tile>

  <!-- heating.circuits.${circuitId}.temperature -->
  <app-feature-tile
    *ngIf="circuitTemperature$ | async | ready as feature"
    feature
    label="{{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.FLOW_TEMPERATURE.TITLE' | translate }}"
    value="{{ feature | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  >
  </app-feature-tile>

  <!-- heating.circuits.${circuitId}.sensors.temperature.supply -->
  <app-feature-tile
    *ngIf="circuitSensorsTemperature$ | async | ready as feature"
    feature
    label="{{ '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.SENSOR_TEMPERATURE.TITLE' | translate }}"
    value="{{ feature | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  >
  </app-feature-tile>

  <!-- heating.circuits.${circuitId}.regulation -->
  <app-feature-tile
    *ngIf="circuitConfigurationRegulation$ | async | ready as feature"
    feature
    label="{{
      '+INSTALLATIONS.INSTALLATION.HEATING_ZONE.CONFIGURATION_REGULATION.TITLE' | translate
    }}"
    [value]="feature.properties?.mode?.value | translateHeatingConfigurationRegulation"
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  >
  </app-feature-tile>

  <ng-container more-menu>
    <button
      data-at-rename-heating-zone
      mat-menu-item
      gtm="onOpen"
      gtmAction="Rename heating zone"
      gtmCategory="heatingZonePanel"
      (click)="openRenameHeatingZoneModal()"
    >
      <span>{{ '+EDIT_HEATING_ZONE_NAME_MODAL.TITLE' | translate }}</span>
    </button>
  </ng-container>
</app-device-features-container>
